/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import PackageDetails from 'ui/components/PackageDetails.vue';

/**
 * This component displays the content inside a tile card.
 *
 * @vue-prop {Object} item the tile item to display.
 * @vue-prop {String[]} item.classes additional classes to add to the card.
 * @vue-prop {String} item.link the URL that this card links to.
 * @vue-prop {Object[]} item.tags a list of `Badge` configuration.
 * @vue-prop {String} item.media the URL to the icon image.
 * @vue-prop {String} item.title the tile of this item.
 * @vue-prop {String} item.tagline a brief text for the card.
 *
 * @example
 * ListTile(:item="myTileItem")
 *
 * @category ui.components
 * @exports ListTile
 * @component
 */
const __vue_script__ = {
    name: 'ListTile',

    components: { Badge },

    props: {
        item: {
            type: Object,
            required: true
        },
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            noMedia: false,
            fallbackMedia: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        };
    },

    computed: {
        media() {
            return this.noMedia ? this.fallbackMedia : this.item.media;
        }
    },

    created() {
        if (!this.item.media) {
            this.noMedia = true;
        }
    },

    methods: {
        openDetails() {
            const params = {
                pkgName: this.item.module.name,
                event: this.event
            };

            this.$modal.show(PackageDetails,
                { params },
                {
                    classes: 'medium',
                    height: 'auto',
                    reset: true
                }
            );
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"list-tile has-action",class:_vm.item.classes,attrs:{"data-cue":_vm.item.module.name},on:{"click":function($event){return _vm.openDetails()}}},[(_vm.item.tags)?_c('div',{staticClass:"tags"},[_vm._l((_vm.item.tags),function(tag){return _c('badge',{attrs:{"config":tag}},[_vm._v(_vm._s(_vm.$t(tag.text)))])}),_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"contents"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.media),expression:"media"}],key:_vm.media,class:[_vm.noMedia ? 'empty' : ''],attrs:{"alt":_vm.item.title}}),_c('i',{staticClass:"ic-package"})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"description"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.tagline))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ListTile.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__